import React from 'react';
import AdminPanel from '../domains/admin/components/AdminPanel';
import DelegatedAdminPanel from '../domains/admin/components/DelegatedAdminPanel';
import { useAuth } from '../domains/auth/contexts/AuthContext';

const AdminPanelPage: React.FC = () => {
  const { userData } = useAuth();
  return userData?.isAdmin === true ? <AdminPanel /> : <DelegatedAdminPanel />;
};

export default AdminPanelPage;
